var __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

define(['jquery', 'core', 'collection/base', 'model/region'], function($, core, BaseCollection, RegionModel) {
  var RegionCollection;
  return RegionCollection = (function(_super) {

    __extends(RegionCollection, _super);

    function RegionCollection() {
      RegionCollection.__super__.constructor.apply(this, arguments);
    }

    RegionCollection.prototype.path = core.getConfig().apiPrefix + 'region.json';

    RegionCollection.prototype.model = RegionModel;

    return RegionCollection;

  })(BaseCollection);
});
